import React from 'react';
// import { Attack } from '../../components/padel/pala';
import Avatar from '../../components/padel/avatar';
import { Link, navigate } from '@reach/router';
import { default as __ } from '../../utils';
import { colors } from '../../styles';

function ActionBar() {
  const [theme, setTheme] = __.usePersistedState('theme', colors.black);
  return (
    <>
      {/* <div className="row-between align-center txt-pointer">
        <Attack
          xl
          cb={() => navigate('/profile', { state: { show: 'pala' } })}
        /> */}

      <Avatar.Regular
        variant="you"
        shade={theme}
        cb={() => navigate('/profile', { state: { show: 'avatar' } })}
        />


      <p className="pill-button txt-uppercase">
        <Link to="new">Añadir partidx</Link>
      </p>
    </>
  );
}

export default ActionBar;
